// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ChevronLeftDouble = createIcon(
  <path
    clipRule="evenodd"
    d="M11.4196 9.24636C11.7711 8.89488 11.7711 8.32504 11.4196 7.97356C11.0681 7.62209 10.4983 7.62209 10.1468 7.97356L6.75521 11.3652C6.40373 11.7166 6.40373 12.2865 6.75521 12.638L10.1468 16.0296C10.4983 16.381 11.0681 16.381 11.4196 16.0296C11.7711 15.6781 11.7711 15.1082 11.4196 14.7568L8.66439 12.0016L11.4196 9.24636ZM17.231 14.7569C17.5825 15.1083 17.5825 15.6782 17.231 16.0297C16.8796 16.3811 16.3097 16.3811 15.9582 16.0297L12.5666 12.6381C12.2152 12.2866 12.2152 11.7167 12.5666 11.3653L15.9582 7.97367C16.3097 7.62219 16.8796 7.62219 17.231 7.97367C17.5825 8.32514 17.5825 8.89499 17.231 9.24646L14.4758 12.0017L17.231 14.7569Z"
    fillRule="evenodd"
  />,
);
